<template>
  <nav class="nav-bar" :class="{ 'nav-bar_bottom': isMobile }">
    <ul class="nav-bar__list">
      <li class="nav-bar__item-wrapper" :class="{ demo: isDemo }">
        <RouterLink to="/orders" class="nav-bar__item"><SvgIcon icon="order" />Заказы </RouterLink>
      </li>
      <!-- <li class="nav-bar__item-wrapper">
        <RouterLink to="/ai" class="nav-bar__item"><SvgIcon icon="ai" />Нейропомощники </RouterLink>
      </li>
      <li class="nav-bar__item-wrapper">
        <RouterLink to="/employee" class="nav-bar__item"
          ><SvgIcon icon="person" />Сотрудники
        </RouterLink>
      </li>
      <li class="nav-bar__item-wrapper">
        <RouterLink to="/history" class="nav-bar__item"
          ><SvgIcon icon="clock" />История
        </RouterLink>
      </li> -->
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useScreenStore } from '@/stores/screen'

const screenStore = useScreenStore()

const isDemo = ref(true)
const isMobile = computed(() => screenStore.isSmallMobile)
</script>

<style scoped lang="scss">
.nav-bar {
  width: 100%;
  height: 100%;
  background-color: $white;
  border-top: 1px solid $borderWhite;
  z-index: 50;

  @include mobile {
    max-width: 757px;
    background-color: transparent;
  }

  &_bottom {
    height: 50px;
    position: fixed;
    left: 0;
    bottom: 0;
  }

  &__list {
    height: 100%;
    display: flex;
  }

  &__item {
    flex: 1;
    @include centering;
    flex-direction: column;
    gap: 5px;

    color: $black40;
    @include textMedium(10px);
    position: relative;

    @include mobile {
      flex-direction: row;
      @include textMedium(15px);
    }

    &::before {
      content: '';
      position: absolute;
      top: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: transparent;
      transition: background-color 0.2s ease-in-out;

      @include mobile {
        display: none;
      }
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: transparent;
      transition: background-color 0.2s ease-in-out;
      display: none;

      @include mobile {
        display: block;
      }
    }

    @media (hover: hover) {
      &:hover {
        &::before {
          background-color: $black40;
        }
        &::after {
          background-color: $black40;
        }
      }
    }
    @media (hover: none) {
      &:active {
        &::before {
          background-color: $black40;
        }
        &::after {
          background-color: $black40;
        }
      }
    }

    &.router-link-active {
      color: $black100;

      &::before {
        background-color: $black100;
      }
      &::after {
        background-color: $black100;
      }
    }

    &-wrapper {
      flex: 1;
      display: flex;

      &.demo {
        @include mobile {
          flex: none;
          flex-basis: 155px;
        }
      }
    }
  }
}
</style>
